export enum LogLevel {
  FATAL = 6,
  CRITICAL = 5,
  ERROR = 4,
  WARN = 3,
  INFO = 2,
  DEBUG = 1,
  TRACE = 0,
}

export const LogLevelText: Record<LogLevel, string> = {
  [LogLevel.FATAL]: 'FATAL',
  [LogLevel.CRITICAL]: 'CRITICAL',
  [LogLevel.ERROR]: 'ERROR',
  [LogLevel.WARN]: 'WARN',
  [LogLevel.INFO]: 'INFO',
  [LogLevel.DEBUG]: 'DEBUG',
  [LogLevel.TRACE]: 'TRACE',
};

export type LogAttributes = Record<string, unknown>;

export type LogFn = (message: string, attributes?: LogAttributes) => void;

export interface Logger {
  fatal: LogFn;
  critical: LogFn;
  error: LogFn;
  warn: LogFn;
  info: LogFn;
  debug: LogFn;
  trace: LogFn;
}
